export default __webpack_public_path__ + "static/media/reims19.efa14901.jpg";